export var SupportedVersions;
(function (SupportedVersions) {
    SupportedVersions["v1"] = "v1";
    SupportedVersions["v2"] = "v2";
})(SupportedVersions || (SupportedVersions = {}));
//# sourceMappingURL=SupportedVersions.js.map